"use client"

import { InputDescription } from "../../components/InputRow/InputDescription"
import { FileInput } from "./FileInput"

interface ImportSubscribersUploadProps {
  fileInputRef: React.RefObject<HTMLInputElement>
  handleFileChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  importInProgress: boolean
}

export function ImportSubscribersUpload({
  fileInputRef,
  handleFileChange,
  importInProgress,
}: ImportSubscribersUploadProps) {
  return (
    <div className="space-y-2">
      <InputDescription>Upload file</InputDescription>
      <FileInput
        className="max-w-[392px]"
        accept=".csv"
        ref={fileInputRef}
        onChange={handleFileChange}
        disabled={importInProgress}
      />
    </div>
  )
}
